import React from 'react';
import Header from '../components/SiteHeader';
import Footer from '../components/SiteFooter';
import ClientPasteWarning from '../client/WarningSystem';
import { ToastContainer, cssTransition } from 'react-toastify';
import { AnnouncementBanner, AnnouncementLevel } from '../components/AnnouncementBanner';
import RouteTags from '../components/RouteTags';
import Feature from '../components/HomepageFeature';
import logo from '../content/BracketedTextLogoLong.svg';
import IconExternalLink from '../components/LinkedContent';
import GuildCardContainer from '../components/ServerCard';
import { GetToastIcon, NotificationTypeOptions } from '../utils/toast';

interface PageConfig {
	Location: string;
	Description?: string;
}

interface FeatureItem {
	title: string;
	description: React.ReactNode;
}

const FeatureList: Array<FeatureItem> = [
	{
		title: 'About',
		description: (
			<p>
				[Bracketed] is a bot built for convenience on discord servers. It offers a wide range of
				commands and modules to use! We offer Roblox services, sort of like bloxlink in a way,
				you can link your groups and ranks to your discord server. You can set up a verification
				wall, and other things to stop those nasty bot accounts from entering your server! We
				also offer the normal range of discord commands, like /ban and /kick and much more! You
				can check out the moderation module in the documentation to see more about that.
			</p>
		),
	},
	{
		title: 'Features',
		description: (
			<ul>
				<li>Moderation Features</li>
				<li>Music Features</li>
				<li>Meme Features</li>
				<li>Application Features</li>
				<li>Ticket Features</li>
				<li>Roblox Features</li>
				<li>Logging Features</li>
				<li>Information Features</li>
				<li>Role Features</li>
			</ul>
		),
	},
	{
		title: 'A note to anyone this may concern:',
		description: (
			<p>
				Hello! Welcome to Bracketed. Please bare with us since the bot is in development at the
				current point in time, if you'd like to know the development state on our bot please
				join our discord today! <br></br>
				<br></br>
				We do not intend to become a rival to other bots on the platform, Bracketed is a bot
				that is built for convenience and fun, we do not intend to become a rival to anyone.
				<br></br>
				<br></br>
				<div
					style={{
						display: 'inline-block',
						whiteSpace: 'nowrap',
					}}>
					<button
						type='button'
						className='button margin-left--md'
						style={{ width: '160px' }}
						onClick={() =>
							window.open(
								'https://bracketed.co.uk/redirects/discord',
								'_blank'
							)
						}>
						Join the discord!
					</button>
					<button
						type='button'
						className='button margin-left--md'
						style={{ width: '210px' }}
						onClick={() =>
							window.open('https://bracketed.co.uk/privacy-policy', '_blank')
						}>
						Read our Privacy Policy
					</button>
				</div>
			</p>
		),
	},
];

export default function App(PageConfig: PageConfig) {
	ClientPasteWarning();

	return (
		<div style={{ backgroundColor: '#242526' }}>
			<RouteTags Location={PageConfig.Location} />
			<Header />
			<ToastContainer
				theme='dark'
				newestOnTop={true}
				draggable={true}
				transition={cssTransition({
					enter: 'animate__animated animate__backInRight',
					exit: 'animate__animated animate__backOutRight',
				})}
				style={{
					background: 'rgba(27, 27, 29, 0.5)',
					backdropFilter: 'blur(20px)',
				}}
				progressStyle={{
					boxShadow: '0px 0px 120px 15px rgba(88,101,242,0.66)',
					backgroundColor: '#5865f2',
					marginBottom: '5px',
					marginLeft: '5px',
					marginRight: '10px',
					borderRadius: '25px',
				}}
				icon={() => GetToastIcon(NotificationTypeOptions.DEFAULT)}
			/>
			<AnnouncementBanner
				msg="Hello and welcome to the beta Bracketed V2 Site! As you can probably tell, version 2 isn't really that finished yet, so tread carefully as some parts of the site are very unstable!"
				level={AnnouncementLevel.NOTICE}
			/>
			<header
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '4rem 0',
					textAlign: 'center',
					position: 'relative',
					overflow: 'hidden',
					height: '1100px',
					backdropFilter: 'blur(20px)',
					backgroundBlendMode: 'exclusion',
					background: 'rgba(36, 37, 38, 0.5)',
					backgroundImage:
						'url(data:image/png;base64,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)',
				}}>
				<div>
					<img
						src={logo}
						style={{
							height: '15rem',
							width: '100%',
							objectFit: 'contain',
						}}
						alt='The [ Bracketed ] logo.'
					/>
					<h1 style={{ fontSize: '50px', color: '#e3e3e3' }}>
						Bracketed - Serving the community.
					</h1>
					<h2
						style={{
							marginTop: '-25px',
							color: '#e3e3e3',
						}}>
						A bot worth using and a bot worth keeping.
					</h2>
					<br />
					<button
						type='button'
						className='button'
						style={{
							marginTop: '20px',
							width: '25%',
						}}
						onClick={() =>
							window.open(
								'https://bracketed.co.uk/redirects/invite',
								'_blank'
							)
						}>
						Invite the bot!
						<IconExternalLink />
					</button>
				</div>
			</header>
			<section
				style={{
					display: 'flex',
					alignItems: 'center',
					padding: '2rem 0',
					width: '100%',
					backgroundColor: 'rgb(27, 27, 29, 1)',
				}}>
				<div className='container'>
					<div
						className='row'
						style={{
							justifyContent: 'center',
							display: 'flex',
						}}>
						{FeatureList.map((props, idx) => (
							<Feature key={idx} {...props} />
						))}
					</div>
				</div>
			</section>

			<section
				style={{
					backgroundColor: '#242526',
					paddingLeft: '600px',
					paddingRight: '600px',
					paddingTop: '50px',
					paddingBottom: '50px',
				}}>
				<GuildCardContainer serverId='1041758169434689628' />
			</section>
			<Footer />
		</div>
	);
}
